import axios from 'axios';


export const  axios_notifs_getnotifs= async(postmail)=>{
    return await axios({method:'POST',url:`/notifs/getnotifs`,data:{'postmail' : postmail },headers:{'Accept':'application/json','Content-Type':'application/json'}})
}

export const  axios_notifs_addnotif= async(notif)=>{ 
    return await axios({method:'POST',url:`/notifs/addnotif`,data:notif,headers:{'Accept':'application/json','Content-Type':'application/json'}});
}

export const  axios_notifs_deletenotif= async(id)=>{
    return await axios({method:'POST',url:`/notifs/deletenotif`,data:{id:id},headers:{'Accept':'application/json','Content-Type':'application/json'}});
}

export const  axios_notifs_updatenotif= async(notif)=>{ 
    return await axios({method:'POST',url:`/notifs/updatenotif`,data:notif,headers:{'Accept':'application/json','Content-Type':'application/json'}});
}

export const  axios_notifs_vidernotifs= async(postmail)=>{
    return await axios({method:'POST',url:`/notifs/vidernotifs`,data:{'postmail' : postmail },headers:{'Accept':'application/json','Content-Type':'application/json'}});           
}



  